import styled from 'styled-components/macro';

export const Wrapper = styled.div`
  display: flex;
  justify-content: center;
  width: 100%;
  height: fit-content;
  margin: auto;
`;
